export default {
    msd: {
        overview: {
            header: {
                lgsmart : "LG",
                dms     : "ELO",
                state   : "S",
                lmstate : "LM",
                sitetype: "A",
                fabricNo: "Fabrik-Nr.",
                id      : "ID",
                customer: "Kunde",
                group   : "Kundengruppe",
                ve      : "VE",
                ve2     : "VE2",
                ve3     : "VE3",
                branch  : "Bereich",
                street  : "Straße",
                city    : "PLZ Ort",
            }
        },
    },
}